import { EncryptStorage } from "encrypt-storage";

export const globalStorage = new EncryptStorage("global_params", {
    storageType: "sessionStorage",
    encAlgorithm: "Rabbit",
});
